import type { User } from '@fleequid-secrets/shared';
import { type ReactNode, useState } from 'react';
import { api, messageOf } from '@/api/client';
import { Brand } from './Brand';

// Email and password, accounts made by an admin, as fleequid-logs.
export function Login(props: { onSignedIn: (user: User) => void }): ReactNode {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    return (
        <div className="login">
            <form
                className="float"
                onSubmit={(event) => {
                    event.preventDefault();
                    setBusy(true);
                    setError(null);
                    api.login(email, password)
                        .then(({ user }) => props.onSignedIn(user))
                        .catch((reason: unknown) => setError(messageOf(reason)))
                        .finally(() => setBusy(false));
                }}
            >
                <Brand />
                <h1>Sign in</h1>
                <p className="lead">The team's environment variables, for every environment.</p>
                <label>
                    <span className="micro">Email</span>
                    <input type="email" autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} required autoFocus />
                </label>
                <label>
                    <span className="micro">Password</span>
                    <input
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        required
                    />
                </label>
                {error && <div className="error">{error}</div>}
                <button className="submit" disabled={busy}>
                    {busy ? 'Signing in…' : 'Sign in'}
                </button>
            </form>
        </div>
    );
}
